import { gql } from '@apollo/client'

export const REMOVE_USER_FROM_ORGANIZATION = gql`
  mutation removeUserFromOrganization($email: String!, $organizationId: String!) {
    removeUserFromOrganization(data: { email: $email, organizationId: $organizationId }) {
      id
    }
  }
`
